import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FlashProps from "@ltypes/flashProps";
import { TextLine } from "@ltypes/scene";
import Product, { ProductModelType } from "@ltypes/product";
import Duration from "@components/forms/Duration/Duration";
import Button from "@components/forms/Button/Button";
import Select from "@components/forms/Select/Select";
import TextFlashLine from "./TextFlashLine";
import { FaPlus } from "react-icons/fa6";
import './TextFlash.scss';

type TextFlashProps = {} & FlashProps;

function TextFlash(props: TextFlashProps) {
    const { t } = useTranslation();
    const product: Product = useSelector((state: any) => state.product);

    const isLegacy = product.model.type === ProductModelType.LEGACY;
    const maxLines: number = isLegacy ? 3 : 10;

    const [duration, setDuration] = useState<string>('00:05:00');
    const [verticalSpacing, setVerticalSpacing] = useState<number>(1);
    const [lines, setLines] = useState<TextLine[]>([{
        text: 'Hello World !',
        textcolor: '#00bfff',
        speed: 50,
        textsize: isLegacy ? 0 : 3,
        textalignment: 1,
    }]);

    const handleChangeLine = (index: number, line: TextLine): void => {
        const updated = [...lines];
        updated[index] = line;
        setLines(updated);
    };

    const handleDeleteLine = (index: number): void => {
        const updated = [...lines];
        updated.splice(index, 1);
        setLines(updated);
    };

    const handleAddLine = (): void => {
        setLines([...lines, {
            text: 'Hello world',
            textcolor: '#00bfff',
            speed: 50,
            textsize: isLegacy ? 0 : 3,
            textalignment: 1,
        }]);
    };

    const handleStart = () => {
        const parts = duration.split(':').map(Number);
        props.onStart({
            display_duration: parts[0] * 3600 + parts[1] * 60 + parts[2],
            lines,
            vertical_spacing: verticalSpacing,
        });
    };

    return (
        <div className="textflash row g-3">
            <div className="col-12">
                <Duration label={t('page.scenes.data.display_duration')} value={duration} showHours onChange={setDuration}/>
            </div>

            {!isLegacy && (
                <div className="col-12">
                    <Select
                        label={t('page.scenes.data.vertical_spacing')}
                        value={verticalSpacing}
                        items={[
                            { label: t('text.top'), value: 0 },
                            { label: t('text.middle'), value: 1 },
                            { label: t('text.bottom'), value: 2 },
                            { label: t('text.space_between'), value: 3 },
                            { label: t('text.space_around'), value: 4 },
                        ]}
                        onChange={(value: string) => setVerticalSpacing(Number(value))}
                    />
                </div>
            )}

            {lines.map((line, index) => (
                <div key={index} className="col-12">
                    <TextFlashLine
                        index={index + 1}
                        line={line}
                        onChange={(l: TextLine) => handleChangeLine(index, l)}
                        onDelete={() => handleDeleteLine(index)}
                    />
                </div>
            ))}

            <div className="col-12 text-center">
                <Button onClick={handleAddLine} disabled={lines.length >= maxLines}>
                    <FaPlus /> {t('page.scenes.add_line')}
                </Button>
            </div>

            <div className="col-12">
                <Button onClick={handleStart} className="w-100">{t('text.create')}</Button>
            </div>
        </div>
    );
}

export default TextFlash;
